import TopBar from './TopBar.js';
const els = document.querySelectorAll('.top-bar');

for (let el of els) {
    new TopBar(el);
}
